import apiClient from '../apiClient';
import { DELETE_ACCOMODATION_BY_PROFILE_ID_URL } from '../apiUrl';

const deleteAccomodationByProfileIdApi = Id => {
  return apiClient.delete(DELETE_ACCOMODATION_BY_PROFILE_ID_URL(Id));
};

export default deleteAccomodationByProfileIdApi;
